/**
 * Linha de tabela de approval no dashboard (F11b §6.5.10).
 *
 * Read-only (ADR-F11-008): apenas exibe + abre modal de detalhes.
 */

import { useState } from 'react';
import { Button } from '../../../design-system/components/Button';
import type { HitlApproval } from '../api';

export interface ApprovalRowProps {
  approval: HitlApproval;
}

function formatTimestamp(iso: string): string {
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

function statusLabel(status: HitlApproval['status']): string {
  switch (status) {
    case 'pending':
      return 'Pendente';
    case 'confirmed':
    case 'executed':
      return 'Confirmada';
    case 'cancelled':
      return 'Cancelada';
    case 'expired':
      return 'Expirada';
    case 'failed':
      return 'Falhou';
  }
}

export function ApprovalRow({ approval }: ApprovalRowProps) {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <tr className="approval-row">
      <td>{formatTimestamp(approval.created_at)}</td>
      <td>{approval.tool_name}</td>
      <td className="approval-row__preview">{approval.preview}</td>
      <td>
        <span className="approval-row__status" data-status={approval.status}>
          {statusLabel(approval.status)}
        </span>
      </td>
      <td>
        <Button variant="ghost" onClick={() => setShowDetails((v) => !v)}>
          {showDetails ? 'Ocultar' : 'Ver detalhes'}
        </Button>
        {showDetails ? (
          <pre className="approval-row__json">{JSON.stringify(approval.payload, null, 2)}</pre>
        ) : null}
      </td>
    </tr>
  );
}
